import React, { useState } from 'react';
import { LoanOfficerCard } from './components/LoanOfficerCard';
import { DocumentList } from './components/DocumentList';
import { UploadModal } from './components/UploadModal';
import { LoanDocument } from './types';
const INITIAL_DOCS: LoanDocument[] = [{
  id: 'doc-1',
  name: 'W-2 Forms (Last 2 Years)',
  description: 'Provide W-2s from all employers for the past two years.',
  status: 'pending'
}, {
  id: 'doc-2',
  name: 'Pay Stubs (Last 30 Days)',
  description: 'Most recent pay stubs covering a 30-day period.',
  status: 'uploaded',
  fileName: 'paystubs_oct_nov.pdf',
  uploadedAt: 'Today, 10:42 AM'
}, {
  id: 'doc-3',
  name: 'Bank Statements (Last 2 Months)',
  description: 'All pages of your checking and savings account statements.',
  status: 'pending'
}, {
  id: 'doc-4',
  name: 'Government-Issued ID',
  description: "Driver's license, passport, or state ID.",
  status: 'approved',
  fileName: 'driver_license_front_back.jpg',
  uploadedAt: 'Oct 12, 2023'
}, {
  id: 'doc-5',
  name: 'Tax Returns (Last 2 Years)',
  description: 'Federal tax returns including all schedules.',
  status: 'pending'
}, {
  id: 'doc-6',
  name: 'Proof of Homeowners Insurance',
  description: 'Declaration page showing coverage amounts and premium.',
  status: 'pending'
}];
export function App() {
  const [documents, setDocuments] = useState<LoanDocument[]>(INITIAL_DOCS);
  const [selectedDoc, setSelectedDoc] = useState<LoanDocument | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleUploadClick = (doc: LoanDocument) => {
    setSelectedDoc(doc);
    setIsModalOpen(true);
  };
  const handleUploadComplete = (documentId: string, file: File) => {
    setDocuments(prevDocs => prevDocs.map(doc => {
      if (doc.id === documentId) {
        return {
          ...doc,
          status: 'uploaded',
          fileName: file.name,
          uploadedAt: 'Just now'
        };
      }
      return doc;
    }));
  };
  return <div className="min-h-screen bg-green-50/50" data-id="element-0">
      {/* Header */}
      <header className="bg-[#1a3a2a] py-4 px-4 sm:px-6 lg:px-8" data-id="element-1">
        <div className="max-w-6xl mx-auto flex items-center justify-between" data-id="element-2">
          <img src="https://cdn.magicpatterns.com/uploads/uZMaTpDJPR1FKx72efDSzM/logo_transparent_(1).png" alt="Lend-A-Loan" className="h-10 w-auto brightness-0 invert" data-id="element-3" />
          <span className="text-white/70 text-sm font-medium" data-id="element-4">
            Document Portal
          </span>
        </div>
      </header>

      <div className="py-8 px-4 sm:px-6 lg:px-8" data-id="element-5">
        <div className="max-w-6xl mx-auto" data-id="element-6">
          {/* Main Content Layout */}
          <div className="flex flex-col lg:flex-row gap-8" data-id="element-7">
            {/* Sidebar - Loan Officer */}
            <div className="w-full lg:w-80 flex-shrink-0" data-id="element-8">
              <div className="sticky top-8" data-id="element-9">
                <LoanOfficerCard data-id="element-10" />
              </div>
            </div>

            {/* Main Content - Document List */}
            <div className="flex-1" data-id="element-11">
              <DocumentList documents={documents} onUploadClick={handleUploadClick} data-id="element-12" />
            </div>
          </div>
        </div>
      </div>

      {/* Upload Modal */}
      <UploadModal isOpen={isModalOpen} document={selectedDoc} onClose={() => setIsModalOpen(false)} onUpload={handleUploadComplete} data-id="element-13" />
    </div>;
}